import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Account Type Summary";
const description = `The Account Type Summary Report is designed to aggregate and display financial transaction data organized by Account Group or Account Type (e.g., Assets, Liabilities, Equity, Revenue, Expenses). For example, under the Asset account group, this report will show the collective transaction data for all accounts classified as assets, providing a high-level, consolidated view of financial activity within that specific category.`;

const images = [
    '/images/reports/purchase-by-supplier/purchase-by-supplier.png', // 0
];


const AccountTypeSummary: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccountTypeSummary;
